import React from 'react';
// import { NavLink } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
// import Logo from '../../../images/logo.png'
// import Routes from '../../../Layout/Routes';
import { STRING, ICONS } from '../../../utils/Constant'

const TopNav = ({ profileSettingHandler, activeClassName, mainMenuHandler, globalSearch,
    showPage, globalPageHandler, globalSearching }) => {
    return (
        <div className="top-fixed dark-background container-fluid">
            <div className="row">
                <div className="col-3 p-0">
                    <i className={"fa menu-icon " + (ICONS.MENU)} onClick={e => mainMenuHandler()} />
                    {/* <NavLink exact={true} to={Routes.DASHBOARD} onClick={e => showPage(e, STRING.HOME)}>
                        <img className="kognetics-logo" src={Logo} alt="kognetics-logo" />
                    </NavLink> */}
                </div>
                <div className="col-6 global-search">
                    <input
                        type="search"
                        placeholder={STRING.GLOBAL_SEARCH}
                        className="form-control"
                        onChange={e => globalSearch(e)}
                        value={globalSearching}
                        onClick={e => globalPageHandler(e, true)}
                    />
                    <i className="fa fa-search" />
                </div>
                <div className="col-3 p-0 header-right-icons">
                    <Tooltip title={STRING.USER_MGMNT} placement="bottom" arrow>
                        <button className={"dashboard-setting-btn " + (activeClassName === STRING.USER_MGMNT ? 'kognetics-actice-class' : '')} onClick={e => profileSettingHandler(STRING.USER_MGMNT)}>
                            <i className={"fa " + (ICONS.USR_MGMNT)} />
                        </button>
                    </Tooltip>
                    <Tooltip title={STRING.HELP + ' - ' + STRING.COMING_SOON} placement="bottom" arrow>
                        <button className={"dashboard-setting-btn " + (activeClassName === STRING.HELP ? 'kognetics-actice-class' : '')} onClick={e => profileSettingHandler(STRING.HELP)}>
                            <i className={"fa " + (ICONS.HELP)} />
                        </button>
                    </Tooltip>
                    <Tooltip title={STRING.ALERTS + ' - ' + STRING.COMING_SOON} placement="bottom" arrow>
                        <button className={"dashboard-setting-btn " + (activeClassName === STRING.ALERTS ? 'kognetics-actice-class' : '')} onClick={e => profileSettingHandler(STRING.ALERTS)}>
                            <i className={"fa " + (ICONS.ALERTS)} />
                        </button>
                    </Tooltip>

                </div>
            </div>
        </div>
    )
}

export default TopNav;

